import React from 'react';
import ToastMessage from './ToastMessage';
import PositiveToast from './PositiveToast';

const DeniedToast = ({ items }) => (
  <PositiveToast className="aridhia-denied-toast">
    <ToastMessage items={items} multiple="toast.denies" single="toast.denied" />
  </PositiveToast>
);

export default DeniedToast;
